<template>
  <Component
      :is="props.tag"
      ref="refNav"
      class="ds-vertical-nav"
      :class="[
      {
        visible: isOverlayNavActive,
        scrolled: isVerticalNavScrolled,
      },
    ]"
  >
    <!-- Header with Logo -->
    <div class="ds-vertical-nav__header">
      <slot name="nav-header">
        <RouterLink to="/" class="ds-vertical-nav__logo">
          <div class="ds-vertical-nav__logo-container">
            <img
                :src="getWhiteLabelSidebarLogo() || getWhiteLabelPortalLogo()"
                alt="logo"
                class="ds-vertical-nav__logo-image"
            />
          </div>
        </RouterLink>
      </slot>
    </div>

    <!-- Navigation Items -->
    <div class="ds-vertical-nav__content">
      <slot
          name="nav-items"
          :update-is-vertical-nav-scrolled="updateIsVerticalNavScrolled"
      >
        <PerfectScrollbar
            :key="isAppRtl"
            tag="ul"
            class="ds-vertical-nav__items"
            :options="{ wheelPropagation: false }"
            @ps-scroll-y="handleNavScroll"
        >
          <li v-for="(item, index) in navBarItem" :key="index" class="nav-link">
            <RouterLink v-if="item.to" :to="item.to" class="d-flex align-center">
              <span v-if="item.svg" class="nav-svg-icon" :style="{ WebkitMaskImage: `url(${itemSvg(item)})`, maskImage: `url(${itemSvg(item)})` }" />
              <Component :is="resolveNavItemComponent(item)" v-else :item="item" />
              <span class="nav-item-title ml-2">{{ item.title }}</span>
            </RouterLink>
            <a v-else-if="item.href" :href="item.href" :target="item.target" class="d-flex align-center">
              <span v-if="item.svg" class="nav-svg-icon" :style="{ WebkitMaskImage: `url(${itemSvg(item)})`, maskImage: `url(${itemSvg(item)})` }" />
              <span class="nav-item-title ml-2">{{ item.title }}</span>
            </a>
          </li>
        </PerfectScrollbar>
      </slot>
    </div>

    <!--    &lt;!&ndash; Action Buttons &ndash;&gt;-->
    <!--    <div class="ds-vertical-nav__actions">-->
    <!--      <div class="ds-vertical-nav__action-buttons">-->
    <!--        <VBtn-->
    <!--          id="add-new-site-btn"-->
    <!--          :class="-->
    <!--            userHasUnpaidInvoice ? 'disabled-button cursor-not-allowed' : ''-->
    <!--          "-->
    <!--          to="/sites/add"-->
    <!--          class="ds-vertical-nav__action-btn"-->
    <!--          prepend-icon="tabler-plus"-->
    <!--        >-->
    <!--          Add New Site-->
    <!--        </VBtn>-->
    <!--        <VBtn-->
    <!--          id="request-migration-btn"-->
    <!--          :class="userHasUnpaidInvoice ? 'disabled-button' : ''"-->
    <!--          to="/sites/add?tab=migration"-->
    <!--          class="ds-vertical-nav__action-btn"-->
    <!--          prepend-icon="v2-icons:req-migration"-->
    <!--        >-->
    <!--          Request Migration-->
    <!--        </VBtn>-->
    <!--      </div>-->
    <!--    </div>-->

    <!-- Admin Buttons Section -->
    <div class="ds-vertical-nav__admin-buttons">
      <!-- Account Notes Button -->
      <VBtn
        v-if="userStore.isAdminUser"
        id="user-account-notes-btn"
        color="primary"
        size="small"
        variant="flat"
        class="ds-vertical-nav__admin-btn mb-2"
        @click="showAccountNotes"
      >
        <VIcon color="on-primary" class="mr-2" size="16">tabler-notes</VIcon>
        Account Notes
      </VBtn>
      
      <VBtn
        v-if="userStore.isAdminUser && !userStore.isWLOwnerAndLoggedInAsCustomer"
        color="secondary"
        size="small"
        variant="flat"
        class="ds-vertical-nav__admin-btn"
        @click="backToAdmin"
      >
        <VIcon class="mr-2" size="16" color="on-primary">mdi-arrow-left</VIcon>
        Back To Admin
      </VBtn>
      <VBtn
        v-if="userStore.isWLOwnerAndLoggedInAsCustomer"
        color="secondary"
        size="small"
        variant="flat"
        class="ds-vertical-nav__admin-btn"
        @click="backToWlDashboard"
      >
        <VIcon class="mr-2" size="16" color="on-primary">mdi-arrow-left</VIcon>
        Back to WL Dashboard
      </VBtn>
    </div>

    <!-- User Profile Section -->
    <div class="ds-vertical-nav__profile">
      <slot name="profile">
        <VMenu v-model="isProfileMenuActive" location="top" offset="8" :close-on-content-click="false">
          <template #activator="{ props: menuProps }">
            <div class="ds-vertical-nav__profile-content" v-bind="menuProps">
              <div class="ds-vertical-nav__profile-avatar">
                <VAvatar size="40">
                  <img
                      v-if="userStore.userProfile?.avatar"
                      :src="userStore.userProfile.avatar"
                      :alt="userStore.userProfile.firstName"
                  />
                  <span v-else class="ds-vertical-nav__profile-initials">
                    {{ userStore.userProfile?.firstName?.charAt(0)
                    }}{{ userStore.userProfile?.lastName?.charAt(0) }}
                  </span>
                </VAvatar>
              </div>
              <div class="ds-vertical-nav__profile-info">
                <div class="ds-vertical-nav__profile-name">
                  {{ userStore.userProfile?.firstName }}
                  {{ userStore.userProfile?.lastName }}
                </div>
                <div class="ds-vertical-nav__profile-email">
                  {{ userStore.userProfile?.email }}
                </div>
              </div>
              <VIcon
                  icon="mdi-chevron-up"
                  size="16"
                  class="ds-vertical-nav__profile-arrow"
              />
            </div>
          </template>

          <VList class="ds-vertical-nav__profile-menu">
            <VListItem
                v-for="item in profileItemFiltered"
                :key="item.title"
                :to="item.title === 'Logout' || item.action === 'openSupportDialog' ? undefined : item.to"
                :href="item.title === 'Logout' || item.action === 'openSupportDialog' ? undefined : item.href"
                class="ds-vertical-nav__profile-menu-item"
                @click="item.title === 'Logout' ? logout() : item.action === 'openSupportDialog' ? rootStore.openSupportDialog() : null"
            >
              <template #prepend>
                <template v-if="item.svg">
                  <span class="nav-svg-icon" :style="{ WebkitMaskImage: `url(${item.svg})`, maskImage: `url(${item.svg})` }" />
                </template>
                <template v-else>
                  <VIcon
                      :icon="item.icon"
                      size="20"
                      :color="item.color || '#032140'"
                  />
                </template>
              </template>
              <VListItemTitle class="ds-vertical-nav__profile-menu-text">
                {{ item.title }}
              </VListItemTitle>
            </VListItem>
          </VList>
        </VMenu>
      </slot>
    </div>
  </Component>

  <!-- Notes Popups -->
  <NotesPopup v-model:is-open="isAccountNotesPopupOpen" level="account" />
</template>

<script setup>
import { PerfectScrollbar } from 'vue3-perfect-scrollbar'
import { injectionKeyIsVerticalNavHovered, useLayouts } from '@layouts'
import { VerticalNavGroup, VerticalNavLink, VerticalNavSectionTitle, } from '@layouts/components'
import { computed, nextTick, provide, ref, watch } from 'vue'
import { useElementHover, useWindowSize } from '@vueuse/core'
import { useRoute, useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { useRootStore } from '@/stores/root'
import { getWhiteLabelPortalLogo, getWhiteLabelSidebarLogo, isBionicSite, } from '@/utils/whiteLabelHelpers'
import { backToWlDashboard } from '@/utils/helpers'
import NotesPopup from '@/views/NotesPopup.vue'
// New SVG icons for left nav profile menu
import svgAccountDetails from '@/assets/images/icons/v3-design/account-details.svg'
import svgAffiliates from '@/assets/images/icons/v3-design/affiliates.svg'
import svgBilling from '@/assets/images/icons/v3-design/billing.svg'
import svgCollaborators from '@/assets/images/icons/v3-design/collaborators.svg'
import svgEmail from '@/assets/images/icons/v3-design/email.svg'
import svgFeatureRequest from '@/assets/images/icons/v3-design/feature-request.svg'
import svgLogout from '@/assets/images/icons/v3-design/logout.svg'
import svgSupport from '@/assets/images/icons/v3-design/support.svg'
import svgWhiteLabel from '@/assets/images/icons/v3-design/white-label.svg'

const props = defineProps({
  tag: {
    type: [String, null],
    required: false,
    default: 'aside',
  },
  navItems: {
    type: null,
    required: true,
  },
  isOverlayNavActive: {
    type: Boolean,
    required: true,
  },
  toggleIsOverlayNavActive: {
    type: Function,
    required: true,
  },
})

const refNav = ref()
const { width: windowWidth } = useWindowSize()
const isHovered = useElementHover(refNav)

const navBarItem = computed(() => {
  return props.navItems.filter((item) => {
    const title = (item.title || '').toString().toLowerCase()

    if (!isBionicSite()) {
      if(title === 'knowledge base')return false
    }

    return true
  })
})

provide(injectionKeyIsVerticalNavHovered, isHovered)

const { isLessThanOverlayNavBreakpoint, isAppRtl } = useLayouts()
const userStore = useUserStore()
const rootStore = useRootStore()
const userHasUnpaidInvoice = computed(() => userStore.userHasUnpaidInvoice)

const resolveNavItemComponent = (item) => {
  if ('heading' in item) return VerticalNavSectionTitle
  if ('children' in item) return VerticalNavGroup

  return VerticalNavLink
}

// helper to resolve dynamic-imported svg
const itemSvg = (item) => {
  // item.svg can be a function returning a promise (dynamic import) or a string
  // Vue will resolve URLs from imported modules when used directly in style mask-image
  return typeof item.svg === 'function' ? undefined : item.svg
}

const route = useRoute()
const router = useRouter()

watch(
  () => route.name,
  () => {
    props.toggleIsOverlayNavActive(false)
  },
)

const isVerticalNavScrolled = ref(false)
const updateIsVerticalNavScrolled = (val) => (isVerticalNavScrolled.value = val)

const handleNavScroll = (evt) => {
  isVerticalNavScrolled.value = evt.target.scrollTop > 0
}

// Profile menu items
//   { title: 'Emails', svg: svgEmail, to: '/emails' },
// { title: 'Feature Requests', svg: svgFeatureRequest, to: '/feature-requests' },
const profileMenuItems = [
  { title: 'Support', svg: svgSupport, action: 'openSupportDialog' },
  { title: 'Collaborators', svg: svgCollaborators, to: '/collaborators' },
  { title: 'White Label', svg: svgWhiteLabel, to: '/white-label' },
  { title: 'Affiliate', svg: svgAffiliates, to: '/affiliate' },
  { title: 'Account Details', svg: svgAccountDetails, to: '/profile' },
  { title: 'API Tokens', icon: 'tabler-key', to: '/api-tokens' },
  { title: 'Billing', svg: svgBilling, to: '/billing' },
  { title: 'Logout', svg: svgLogout, href: '#' },
]

const profileItemFiltered = computed(() => {
  const isWhiteLabelCustomer = userStore.isWLCustomer
  return profileMenuItems.filter((item) => {
    const title = (item.title || '').toString().toLowerCase()

    // Hide Support when WL platform requests hiding support form
    if (
      userStore.wlPlatformOfCustomer?.hide_support_form &&
        ( title === 'support')
    ) {
      return false
    }

    // billing hidden under specific WL platform condition (kept as-is)
    if (
      title === 'billing' &&
        userStore.wlPlatformOfCustomer?.is_offline_billing_enabled
    ) {
      return false
    }

    // Show API Tokens only if user has API access enabled
    if (title === 'api tokens') {
      return userStore.userProfile?.has_api_access === true
    }

    // Bionic site: when WL owner logged in as customer, hide White Label entry
    if (isBionicSite()) {
      const isWhiteLabelItem = title === 'white label'
      if (userStore.isWLOwnerAndLoggedInAsCustomer && isWhiteLabelItem) return false
      return true
    }

    // WL customer: hide Affiliate and White Label entries (match by route name or title)
    if (isWhiteLabelCustomer) {
      const isAffiliateItem = title === 'affiliate'
      const isWhiteLabelItem =  title === 'white label'
      if (isAffiliateItem || isWhiteLabelItem) return false
    }

    return true
  })
})

const logout = async () => {
  try {
    localStorage.removeItem('customer-uuid')
  } catch {}
  // Close profile menu before navigating to avoid overlay unmount glitches
  isProfileMenuActive.value = false
  await nextTick()
  await userStore.logout()
  // Defer navigation slightly to ensure overlays unmount cleanly
  setTimeout(async () => {
    await router.push('/login')
  }, 0)
}

const backToAdmin = async () => {
  localStorage.removeItem('customer-uuid')
  await userStore.backToAdmin()
  await router.replace('/admin')
}

// Notes functions
const showAccountNotes = () => {
  isAccountNotesPopupOpen.value = true
}


// Controls profile menu visibility
const isProfileMenuActive = ref(false)

// Notes functionality
const isAccountNotesPopupOpen = ref(false)
</script>

<style scoped lang="scss">
.ds-vertical-nav {
  position: fixed;
  z-index: 1004;
  display: flex;
  flex-direction: column;
  height: 100dvh;
  width: 300px; /* Your requested width */
  top: 0;
  left: 0;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, width 0.3s ease;
  overflow: hidden;
}

/* Header */
.ds-vertical-nav__header {
  padding: 21px 20px;
  position: relative;
}

.ds-vertical-nav__logo {
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  width: 100%;
}

.ds-vertical-nav__logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
}

.ds-vertical-nav__logo-image {
  width: 164px; /* Your requested width */
  height: 30px; /* Your requested height */
  object-fit: contain;
  border: none; /* Border removed as requested */
}

/* Close Button */
.ds-vertical-nav__close-button {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.ds-vertical-nav__close-button:hover {
  background: #f8f9fa;
  border-color: #d0d0d0;
}

/* Content */
.ds-vertical-nav__content {
  flex: 1;
  overflow: hidden;
}

.ds-vertical-nav__items {
  padding-bottom: 16px;
  height: 100%;
}

/* Navigation Items Styling */
.ds-vertical-nav :deep(.nav-link) {
  margin: 4px 16px;
  border-radius: 8px;
  transition: all 0.2s ease;
  &:hover {
    .v-icon {
      color: rgb(var(--v-theme-secondary)) !important;;
    }
    .nav-svg-icon{
      background-color: rgb(var(--v-theme-secondary)) !important;
    }
  }
  .router-link-active, .router-link-exact-active {
    .v-icon {
     color: rgb(var(--v-theme-secondary)) !important;;
    }
    .nav-svg-icon{
      background-color: rgb(var(--v-theme-secondary)) !important;
    }
  }
}

.ds-vertical-nav :deep(.nav-link a) {
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  background: rgb(var(--v-theme-textfield-bg));;
  color: rgb(var(--v-theme-text-color));
  text-decoration: none;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  transition: all 0.2s ease;
}

.ds-vertical-nav :deep(.nav-link a:hover) {
  background: rgb(var(--v-theme-textfield-bg));
  color: rgb(var(--v-theme-text-color));
}

.ds-vertical-nav :deep(.nav-link.router-link-active a) {
  background: rgb(var(--v-theme-textfield-bg));
  color: rgb(var(--v-theme-text-color));
}

.ds-vertical-nav :deep(.nav-item-icon) {
  margin-right: 12px;
  width: 20px;
  height: 20px;
  color: rgb(var(--v-theme-text-color));
}

.ds-vertical-nav :deep(.nav-link.router-link-active .nav-item-icon) {
  color: rgb(var(--v-theme-secondary));
}

.ds-vertical-nav :deep(.nav-item-title) {
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: rgb(var(--v-theme-text-color));
}

/* Action Buttons */
.ds-vertical-nav__actions {
  padding: 16px 20px;
  border-top: 1px solid #f0f0f0;
}

.ds-vertical-nav__action-buttons {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ds-vertical-nav__action-btn {
  width: 100%;
  border-radius: 12px;
  font-weight: 500;
  text-transform: none;
  height: 44px;
}

/* Admin Buttons Section */
.ds-vertical-nav__admin-buttons {
  padding: 0px 20px;
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ds-vertical-nav__admin-btn {
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  text-transform: none;
  border-radius: 8px;
  height: 40px;
}

/* Profile Section */
.ds-vertical-nav__profile {
  padding: 16px 20px;
}

.ds-vertical-nav__profile-content {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  background-color: rgb(var(--v-theme-textfield-bg));
  transition: background-color 0.2s ease;
}


.ds-vertical-nav__profile-avatar {
  flex-shrink: 0;
}

.ds-vertical-nav__profile-info {
  flex: 1;
  min-width: 0;
}

.ds-vertical-nav__profile-name {
  font-weight: 600;
  font-size: 14px;
  color: #1f2937;
  margin-bottom: 2px;
}

.ds-vertical-nav__profile-email {
  font-size: 12px;
  color: #6b7280;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ds-vertical-nav__profile-arrow {
  color: #6b7280;
  transition: color 0.2s ease;
}

.ds-vertical-nav__profile-initials {
  font-weight: 600;
  color: #ffffff;
}




/* Overlay nav */
.ds-vertical-nav.overlay-nav {
  &:not(.visible) {
    transform: translateX(-300px);
  }
}

.ds-vertical-nav.overlay-nav.visible {
  transform: translateX(0);
}

/* Utility Classes */
.disabled-button {
  pointer-events: none;
  opacity: 0.5;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

/* Responsive Design */
@media (max-width: 768px) {
  .ds-vertical-nav {
    width: 300px;
  }

  .ds-vertical-nav.overlay-nav {
    &:not(.visible) {
      transform: translateX(-300px);
    }
  }
}

///* RTL Support */
//[dir='rtl'] .ds-vertical-nav {
//  left: 55px;
//  right: 0;
//  border-radius: 16px 0 0 16px;
//}
//
//[dir='rtl'] .ds-vertical-nav.overlay-nav {
//  &:not(.visible) {
//    transform: translateX(300px);
//  }
//}
</style>
<style lang="scss">
/* profile overlay menu in navigation bar */
.ds-vertical-nav__profile-menu{
  background-color: rgb(var(--v-theme-textfield-bg)) !important;
  border-radius: 8px;
  box-shadow: none !important;
  width: 260px;
  padding: 8px 0;
  .v-list-item__overlay{
    background: transparent !important;
  }
  .v-list-item__prepend{
    width: 30px !important;
  }
  .ds-vertical-nav__profile-menu-item {
    padding: 0 16px;
    margin: 7.5px 0;
    transition: background-color 0.2s ease;
    min-height: 40px;
    display: flex;
    align-items: center;
    &:hover{
      background-color: transparent;
      .v-icon{
        color: rgb(var(--v-theme-secondary)) !important;
      }
      .nav-svg-icon{
        background-color: rgb(var(--v-theme-secondary)) !important;
      }
    }
  }
  .ds-vertical-nav__profile-menu-text {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    color: rgb(var(--v-theme-text-color));
  }
}

/* Masked SVG icon to allow color transitions like VIcon */
.nav-svg-icon{
  display: inline-block;
  width: 20px;
  height: 20px;
  background-color: rgb(var(--v-theme-primary)); /* default icon color */
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-position: center;
  mask-position: center;
  transition: background-color 0.2s ease;
}
</style>